<template>
 <div class="back d-flex mb-2 d-flex justify-content-between" :class="{'cursor-pointer': action}">
    <div>
        <i class=" fs-3 me-2 " :class="icon"></i>
        <h7>
            {{ title }}
        </h7>
    </div>
   <h6>
    <slot/>
   </h6>
</div>
</template>
<script setup>
defineProps({
    title: String,
    icon: String,
    action: {type: Boolean, default: false}
})
</script>
<style>
.back{
    background-color: var(--bs-light-primary);
    border-radius: 8px;
  padding: 10px;
  width: auto;
}
</style>